import { render } from "./LazyImg.vue?vue&type=template&id=34d7ec7a&scoped=true"
import script from "./LazyImg.vue?vue&type=script&lang=js"
export * from "./LazyImg.vue?vue&type=script&lang=js"

import "./LazyImg.vue?vue&type=style&index=0&id=34d7ec7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d7ec7a"]])

export default __exports__